/**
 * Inquiry Form - SKU情報の自動取得
 * 商品オプション選択時に、選択されたSKU情報を自動的にフォームに設定する
 */

(function() {
  'use strict';

  // お問い合わせフォームが存在しない場合は処理しない
  var inquiryForm = document.querySelector('.inquiry-form');
  if (!inquiryForm) return;

  var selectedOptionsInput = document.getElementById('inquiry-selected-options');
  if (!selectedOptionsInput) return;

  /**
   * 選択されたSKU情報を取得して更新
   */
  function updateSelectedOptions() {
    var options = [];

    // 各オプション（1, 2, 3）をループ
    for (var i = 1; i <= 3; i++) {
      // data-option-position属性でコンテナを取得
      var container = document.querySelector('[data-option-position="' + i + '"]');
      if (!container) continue;

      // オプション名を取得
      var optionName = container.getAttribute('data-option-name');
      if (!optionName) continue;

      // 選択された値を取得
      var selectedInput = document.querySelector('input[name="option' + i + '"]:checked');
      if (!selectedInput) continue;

      options.push(optionName + ': ' + selectedInput.value);
    }

    selectedOptionsInput.value = options.join(', ');
  }

  // バリアント選択時にSKU情報を更新
  var variantOptions = document.querySelectorAll('.variant-option');
  variantOptions.forEach(function(option) {
    option.addEventListener('change', updateSelectedOptions);
  });

  // 初期値を設定
  updateSelectedOptions();

})();
